import { css } from "aphrodite";
import { CustomAppBar } from "./components/CustomAppBar";
import { CustomFooter } from "../common/components/CustomFooter";
import styles from "./styles";

const Layout = ({ children, webView = true }) => {
    return (
        <div className={css(styles.container)}>
            <CustomAppBar webView={webView} />
            <div className={css(styles.contentWrapper)}>
                {children}
            </div>
            <CustomFooter webView={webView} />
        </div>
    );
};

export default Layout;
